"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_EVENTS = exports.MAX_STALLED_RETRIES = exports.MAX_WAIT_FOR_SCENE_LOAD = exports.BUFFERING_DELTA = exports.DEFAULT_VIDEOJS_OPTIONS = exports.PLAYBACK_REFRESH_RATE = exports.IMAGEKIT_URL = exports.WEBM_TRANSFORM = exports.MP4_TRANSFORM = exports.DEFAULT_QUALITY = exports.STREAM_TRANSFORM = exports.THUMBNAIL_TRANSFORM = exports.MIN_SCENES_LOADED_RATIO = exports.MAX_RETRIES = exports.FETCH_MEDIA_TIMEOUT = exports.MIN_BUFFERED_PERCENT = exports.DEBUG = void 0;
exports.DEBUG = false;
exports.MIN_BUFFERED_PERCENT = 0.6;
exports.FETCH_MEDIA_TIMEOUT = 1000;
exports.MAX_RETRIES = 10;
exports.MIN_SCENES_LOADED_RATIO = 1;
exports.THUMBNAIL_TRANSFORM = '/ik-thumbnail.jpg';
exports.STREAM_TRANSFORM = '/ik-master.m3u8?tr=sr-240_360_480_720';
exports.DEFAULT_QUALITY = 40;
exports.MP4_TRANSFORM = `?tr=f-mp4,q-${exports.DEFAULT_QUALITY}`;
exports.WEBM_TRANSFORM = `?tr=f-webm,q-${exports.DEFAULT_QUALITY}`;
exports.IMAGEKIT_URL = 'https://ik.imagekit.io/adificialio';
exports.PLAYBACK_REFRESH_RATE = 100;
exports.DEFAULT_VIDEOJS_OPTIONS = {
    controls: false,
    suppressNotSupportedError: false,
    techOrder: ['html5'],
    fullscreen: { options: { navigationUI: 'hide' } },
    preferFullWindow: true,
    userActions: { click: false, doubleClick: false },
};
exports.BUFFERING_DELTA = 0.25;
exports.MAX_WAIT_FOR_SCENE_LOAD = 1000;
exports.MAX_STALLED_RETRIES = 5;
exports.VIDEO_EVENTS = [
    // HTMLMediaElement events
    'abort',
    'canplay',
    'canplaythrough',
    // 'durationchange',
    'emptied',
    'ended',
    'error',
    'loadeddata',
    // 'loadedmetadata',
    'loadstart',
    'pause',
    'play',
    'playing',
    // 'progress',
    'ratechange',
    'seeked',
    'seeking',
    'stalled',
    'suspend',
    // 'timeupdate',
    // 'volumechange',
    'waiting',
    // HTMLVideoElement events
    'enterpictureinpicture',
    'leavepictureinpicture',
    // Element events
    'fullscreenchange',
    // 'resize',
    // video.js events
    'audioonlymodechange',
    'audiopostermodechange',
    'controlsdisabled',
    'controlsenabled',
    'debugon',
    'debugoff',
    'disablepictureinpicturechanged',
    'dispose',
    'enterFullWindow',
    'error',
    'exitFullWindow',
    'firstplay',
    'fullscreenerror',
    'languagechange',
    'loadstart',
    'playerreset',
    'playerresize',
    'posterchange',
    // 'ready',
    'textdata',
    'useractive',
    // 'userinactive',
    'usingcustomcontrols',
    'usingnativecontrols',
];
